import { styled } from '@pata-app/themes';

export const HighlevelBenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.core.sizing[5]}px;
  padding: 70px 0;

  h2 {
    text-align: center;
  }
`;

export const BenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.core.sizing[4]}px;

  @media ${({ theme }) => `${theme.core.breakpoints.m}`} {
    flex-direction: row;
  }
`;
